import { createFileRoute } from "@tanstack/react-router";
import AtlasVsChatGPTGuide from "@/pages/resources/AtlasVsChatGPTGuide";

export const Route = createFileRoute("/learn/atlas-vs-chatgpt-study")({
  head: () => ({
    meta: [
        {
            "title": "System Atlas vs ChatGPT for Studying: Honest Comparison | 2026"
        },
        {
            "name": "description",
            "content": "Should you study with ChatGPT or System Atlas? Honest comparison of features, strengths, and weaknesses for students. Feature table and real use cases."
        },
        {
            "property": "og:title",
            "content": "System Atlas vs ChatGPT for Studying: Honest Comparison | 2026"
        },
        {
            "property": "og:description",
            "content": "Should you study with ChatGPT or System Atlas? Honest comparison of features, strengths, and weaknesses for students. Feature table and real use cases."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/atlas-vs-chatgpt-study"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "System Atlas vs ChatGPT for Studying: Honest Comparison | 2026"
        },
        {
            "name": "twitter:description",
            "content": "Should you study with ChatGPT or System Atlas? Honest comparison of features, strengths, and weaknesses for students. Feature table and real use cases."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/atlas-vs-chatgpt-study"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/atlas-vs-chatgpt-study"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/atlas-vs-chatgpt-study"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/atlas-vs-chatgpt-study"
        }
    ],
  }),
  component: AtlasVsChatGPTGuide,
});
